import React from "react";
import { Route, Routes } from "react-router-dom";
import ROUTES from "./routePaths";

import Login from "../pages/Login";
import Home from "../pages/Home";
import Drivers from "../pages/Drivers";
import Requests from "../pages/Requests";
import Balances from "../pages/Balances";
import Customers from "../pages/Customers";
import Accounts from "../pages/Accounts";
import Unauthorized from "../pages/Unauthorized";

import DashboardLayout from "../layouts/DashboardLayout";

import ProtectedRoute from "../components/ProtectedRoute";
import RedirectAfterLogin from "../pages/RedirectAfterLogin";
import DriverProfilePage from "../pages/DriverProfile";
import UserProfilePage from "../pages/UserProfile";
import AdminProfilePage from "../pages/Profile";
import BagManagerRequests from "../pages/BagManager";

const Router = () => {
  return (
    <Routes>
      <Route index path={ROUTES.LOGIN} element={<Login />} />
      <Route path={ROUTES.UNAUTHORIZED} element={<Unauthorized />} />
      <Route path={ROUTES.REDIRECT} element={<RedirectAfterLogin />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path={ROUTES.HOME} element={<Home />} />
          <Route path={ROUTES.CUSTOMERS} element={<Customers />} />
          <Route path={ROUTES.DRIVERS} element={<Drivers />} />
          <Route path={ROUTES.REQUESTS} element={<Requests />} />
          <Route path={ROUTES.BALANCES} element={<Balances />} />
          <Route path={ROUTES.ACCOUNTS} element={<Accounts />} />
          <Route path={ROUTES.DRIVER_PROFILE} element={<DriverProfilePage />} />
          <Route path={ROUTES.USER_PROFILE} element={<UserProfilePage />} />
          <Route path={ROUTES.PROFILE} element={<AdminProfilePage />} />
          <Route path={ROUTES.BAG_MANAGER} element={<BagManagerRequests />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default Router;
